import { BreakpointObserver } from '@angular/cdk/layout';
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { SpinnerService } from './layout/spinner.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewChecked, AfterViewInit {
  title = 'backend';
  spinnerStarted: any;
  isLoginPage = true;
  sidenavWidth = 4;

  @ViewChild(MatSidenav) matSidenav!: MatSidenav;

  constructor(
    private spinnerService: SpinnerService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private observer: BreakpointObserver
  ) { }

  increase() {
		this.sidenavWidth = 15;
		console.log('increase sidenav width');
	}
	decrease() {
		this.sidenavWidth = 4;
		console.log('decrease sidenav width');
	}

  ngAfterViewInit(): void {
    this.observer.observe(['(max-width: 800px)']).subscribe((res) => {
      if (res.matches) {
        this.matSidenav.mode = 'over';
        this.matSidenav.close();
      } else {
        this.matSidenav.mode = 'side';
        this.matSidenav.open();
      }
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((val) => {
      this.cdRef.detectChanges();

      if (this.router.url.indexOf('/login')) {
        this.isLoginPage = true;
        return true;
      } else {
        this.isLoginPage = false;
      }
    });
    this.spinnerService.spinner$.subscribe((data: any) => {
      this.spinnerStarted = data;
    });
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
}
